/**
 * Next 14 days — V98-3-3. Overdue split out as a count that points up to
 * where the red lives (Owed / Open by owner); dated items by day with their
 * owners from routing. Never red here (red once, highest tier).
 *
 * V98-3 review U14: hard dates (filings, external deadlines) carry a "Hard"
 * tag; every item links to its record; titles are the canonical ones.
 */
import { Link } from 'react-router-dom';
import { fmtDay, itemHref, next14, type DatedItem } from '../../lib/today-model';
import { Chip } from './shared';

export function NextDays({ items, todayDay, prefix, isLead }: { items: readonly DatedItem[]; todayDay: string; prefix: string; isLead: boolean }) {
  const { overdue, days } = next14(items, todayDay);
  const mineOverdue = overdue.filter((i) => i.inOwed).length;
  const othersOverdue = overdue.length - mineOverdue;
  return (
    <>
      {overdue.length ? (
        <p className="gp-sec-count" data-part="overdue-split">
          {'Overdue '}<b>{overdue.length}</b>
          {mineOverdue ? <> · <a href="#owed">{`${mineOverdue} in Owed`}</a></> : null}
          {othersOverdue && isLead ? <> · <a href="#owners">{`${othersOverdue} in Open by owner`}</a></> : null}
        </p>
      ) : null}
      {days.length ? (
        <ol className="gp-days" aria-label="Next 14 days">
          {days.map((d) => (
            <li key={d.date} className="gp-day">
              <time dateTime={d.date}>{d.date === todayDay ? 'Today' : fmtDay(d.date)}</time>
              <ul>
                {d.items.map((i) => (
                  <li key={i.key}>
                    {i.hard ? <><Chip text="Hard" tone="outline" />{' '}</> : null}
                    {i.ref ? <Link to={itemHref(prefix, i.ref)}>{i.title}</Link> : <span>{i.title}</span>}
                    <span className="gp-dim">{` · ${i.inOwed ? 'you · in Owed' : i.owners.join(', ')}`}</span>
                  </li>
                ))}
              </ul>
            </li>
          ))}
        </ol>
      ) : <p className="gp-dim">Nothing due in the next 14 days.</p>}
    </>
  );
}
